import { jsx as _jsx } from "react/jsx-runtime";
import { getOrientacoesSexuais } from '../../../api';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import GridBase from '../../../components/grid_base';
var COLUNAS = [
    { field: 'nome', headerName: 'Nome', width: 650 },
    { field: 'situacao', headerName: 'Situação', width: 150 },
];
export default function OrientacoesSexuais() {
    return (_jsx(GridBase, { pagina: PAGINAS.ORIENTACOES_SEXUAIS, paginaPermissao: FUNCIONALIDADES.ORIENTACOES_SEXUAIS, rota: ROUTES.ORIENTACOES_SEXUAIS, fetchData: function (str, _, pag) { return getOrientacoesSexuais(str, pag); }, columns: COLUNAS }));
}
